import { LayoutGrid, List, Rows3, type LucideIcon } from 'lucide-react';
import { ToggleGroup, ToggleGroupItem } from './toggle-group.js';

/** Ordre d'affichage : liste, détails, cartes. Cartes reste le mode par défaut côté appelant. */
export const VIEW_MODES = ['list', 'details', 'cards'] as const;
export type ViewMode = (typeof VIEW_MODES)[number];

const ICONS: Record<ViewMode, LucideIcon> = {
  list: List,
  details: Rows3,
  cards: LayoutGrid,
};

/**
 * Sélecteur Liste / Détails / Cartes. Les libellés viennent de l'appelant : ce paquet ne porte
 * aucune langue. Un clic sur le mode déjà choisi ne le retire pas.
 */
export function ViewModeSwitch({
  value,
  onValueChange,
  labels,
  label,
}: {
  value: ViewMode;
  onValueChange: (mode: ViewMode) => void;
  labels: Record<ViewMode, string>;
  label: string;
}) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      variant="outline"
      size="sm"
      aria-label={label}
      data-testid="view-mode-switch"
      className="justify-start"
      onValueChange={(next) => {
        if (next === 'list' || next === 'details' || next === 'cards') onValueChange(next);
      }}
    >
      {VIEW_MODES.map((mode) => {
        const Icon = ICONS[mode];
        return (
          <ToggleGroupItem key={mode} value={mode} data-testid={`button-view-${mode}`}>
            <Icon aria-hidden />
            {labels[mode]}
          </ToggleGroupItem>
        );
      })}
    </ToggleGroup>
  );
}
